
const Listener = function (listener, proxy, src, type, capture, opt_handler) {
  this.listener = listener
  this.proxy = proxy
  this.src = src
  this.type = type
  this.handler = opt_handler
}

Listener.prototype.destroy = function () {
  delete this.listener
  delete this.proxy
  delete this.src
  delete this.type
  delete this.handler
}

export default Listener
